import {ExpectedError} from '@di-shared/features/common/CustomError';
import HistoryDate from '@di-shared/features/history/date/HistoryDate';
import {parseDateWithFormat} from '@shared/dateUtils';

interface HistoryDatePageProps {
  vin: string;
  date: string;
}

export default function HistoryDatePage({vin, date}: HistoryDatePageProps) {
  const verifiedDate = parseDateWithFormat(date);

  if (!verifiedDate) {
    throw new ExpectedError('HistoryDate parse error');
  }

  return (
    <HistoryDate
      vin={vin}
      date={verifiedDate}
    />
  );
}
